export const PATHS = {
  payTask: '/guest/pay-task',
  bindingTasks: '/guest/binding-tasks',
  markTaskPaid: '/guest/mark-paid',
  account: '/settings/account',
  admiinAccount: '/admiin-account',
  business: '/settings/business',
  changePassword: '/change-password',
  settingsChangePassword: '/settings/change-password',
  //changePassword: '/change-password',
  conversations: '/conversations',
  dashboard: '/dashboard',
  home: '/home',
  taskBox: 'taskbox',
  tasks: '/tasks',
  entitySubRoute: '/:entityId',
  taskBoxDetail: 'taskbox/:id',
  contacts: '/contacts',
  clients: '/clients',
  clientDetail: '/clients/:id',
  archivedClients: '/clients/archived',
  integrations: '/settings/integrations',
  paymentMethods: '/settings/paymentMethods',
  notifications: '/settings/notifications',
  onboardingComplete: '/onboarding-complete',
  onboardingBusiness: '/onboarding-business',
  onboardingName: '/onboarding-name',
  onboardingProfileImage: '/onboarding-profile-image',
  onboardingCheckoutConfirm: '/onboarding-checkout',
  plans: '/plans',
  resetPassword: '/reset-password',
  rewards: '/rewards',
  root: '',
  security: '/settings/security',
  receivingAccounts: '/settings/receivingAccounts',
  firmOnboarding: '/firm-onboarding',
  settings: '/settings',
  signUp: '/sign-up',
  signIn: '/sign-in',
  support: '/settings/support',
  templates: '/templates',
  transactions: '/settings/transactions',
  checkoutConfirm: '/checkout',
  subscriptions: '/subscriptions',
  swipes: '/swipes',
  tags: '/tags',
  team: '/team',
  teamCreate: '/team/create',
  teamUpdate: '/team/update',
  user: '/user/view',
  users: '/settings/users',
  userUpdate: '/user/update',
  xeroRedirect: '/xero-redirect',
  xeroRedirectAccouting: '/xero-redirect-accounting',
  xeroRedirectContacts: '/xero-redirect-contacts',
  verify: '/verify',
  xeroContacts: '/xero-contacts',
  xeroTransactions: '/xero-transactions',
  referrals: '/referrals',
  services: '/services',
  documents: '/documents',
  inbox: '/inbox',
};
